// @core/api/endpoints/team/list_my_delegations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRoleDelegationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List delegations I created
 * Returns a paginated list of my delegations. Supports filtering and sorting.
 */
export async function ListMyDelegations(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRoleDelegationsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/my-delegations`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListRoleDelegationsResponse>(requestPath, { ...requestOptions, params });
}
